module.exports = __webpack_public_path__ + "img/balao_balao_5.86c7fad1.svg";